export const tr = {
    'ad-group-bad-geo-for-belarusian':
        "{bannerId} reklamının metni Belarusça olduğu için gösterim bölgesi değiştirilemez. Gösterimler sadece Beyaz Rusya'da yapılabilir.",
    'ad-group-bad-geo-for-default': '{bannerId} reklamının dili seçilen gösterim bölgesine uygun değil.',
    'ad-group-bad-geo-for-kazakh':
        "{bannerId} reklamının metni Kazakça olduğu için gösterim bölgesi değiştirilemez. Gösterimler sadece Kazakistan'da yapılabilir.",
    'ad-group-bad-geo-for-turkish':
        "{bannerId} reklamının metni Türkçe olduğu için gösterim bölgesi değiştirilemez. Gösterimler sadece Türkiye'de yapılabilir.",
    'ad-group-bad-geo-for-ukraine':
        "{bannerId} reklamının metni Ukraynaca olduğu için gösterim bölgesi değiştirilemez. Gösterimler sadece Ukrayna'da yapılabilir.",
    'default-error': 'Bilinmeyen hata: {codeError}',
    'general-rate-required': 'Yeni koşullar için teklif belirtin',
    'geo-empty-regions': 'Gösterim bölgeleri seçilmelidir',
    'geo-ids-incorrect-regions': 'Geçersiz bölge belirtildi: {regionIds}',
    'geo-minus-region-matches-plus-region':
        'Hatalı format: Hariç tutulan {minusRegionIds} bölgesi {regionIds} gösterim bölgesini çıkaramaz',
    'geo-minus-regions-without-plus-regions':
        'İstisnada, hiçbir gösterim bölgesinde yer almayan bölgeler mevcut: {regionIds}',
    'geo-no-plus-regions': 'Gösterim bölgesi yok',
    'incorrect-goal-id': 'Yanlış hedef belirtildi',
    'invalid-max-value-level': 'Değer maksimum {max} olabilir',
    'key-words-limit': '{count} anahtar sözcük grubunda sınırlama aşıldı',
    'library-list-minus-keywords-max': 'Maksimum bağlı dizi sayısı: {maxSize}',
    'library-list-minus-keywords-object-not-found': 'Silinen diziyi seçtiniz',
    'max-groups-in-campaign': 'Kampanyada maksimum grup sayısına ulaşıldı',
    'max-retargetings-size': {
        one: 'En fazla {count} koşul seçilebilir',
        some: 'En fazla {count} koşul seçilebilir',
        many: 'En fazla {count} koşul seçilebilir',
        none: ''
    },
    'minus-keywords-max-length':
        'Negatif anahtar sözcük grubunda izin verilen kelime uzunluğu {maxLength} karakter aşıldı. Sözcük gruplarında hatalar: {minusWords}',
    'name-empty': 'Grup adı belirtilmedi',
    'name-max-length': 'Grup adı {maxLength} karakterden uzun olamaz',
    'name-prohibited-symbols': 'Grup adı yasak karakterler içeriyor',
    'page-blocks-are-required': 'Reklam platformları seçmelisiniz',
    'phrase-cannot-be-empty': 'Anahtar sözcük grubu boş bırakılamaz',
    'phrase-illegal-characters':
        'Anahtar sözcük gruplarının metninde sadece Türkçe, İngilizce, Kazakça, Rusça, Ukraynaca veya Belarusça harfler, tırnak işaretleri, boşluk ve "-", "+", "!" işaretleri kullanılabilir. Anahtar sözcük grubunda hata oluştu: {phrase}',
    'phrase-incorrect-use-of-parenthesis':
        'İşleç kullanılırken hata, anahtar sözcük grubunda yer almayan parantez kullanılabilir: {phrase}',
    'phrase-invalid-apostrophe': 'Anahtar sözcük gruplarında "\'" işaretinin hatalı kullanımı: {phrase}',
    'phrase-invalid-brackets': 'Anahtar sözcük gruplarında [] köşeli parantezin hatalı kullanımı: {phrase}',
    'phrase-invalid-exclamation-mark': 'Anahtar sözcük gruplarında "!" işaretinin hatalı kullanımı: {phrase}',
    'phrase-invalid-minus-mark': 'Anahtar sözcük gruplarında "-" işaretinin hatalı kullanımı: {phrase}',
    'phrase-invalid-plus-mark': 'Anahtar sözcük gruplarında "+" işaretinin hatalı kullanımı: {phrase}',
    'phrase-invalid-point': 'Anahtar sözcük grubunda özel karakterlerin yanlış kombinasyonu: {phrase}',
    'phrase-invalid-quotes': 'Anahtar sözcük grubunda tırnak işaretinin hatalı kullanımı: {phrase}',
    'phrase-minus-keywords-max-length':
        '"{minusWord}" negatif anahtar sözcüğünün izin verilen maksimum uzunluğu {maxLength} karakter aşıldı.',
    'phrase-minus-word-delete-plus-word': 'Ana anahtar sözcük grubunda bulunan ({word}) sözcüğü çıkarılamaz: {phrase}',
    'phrase-minus-word-inside-brackets-or-quotes':
        'Negatif anahtar sözcükler tırnak işareti veya köşeli parantez içinde olamaz. Anahtar sözcük grubunda hata var: {phrase}',
    'phrase-no-plus-words': 'Anahtar sözcük grubu sadece negatif anahtar sözcüklerden oluşamaz',
    'phrase-not-single-minus-word':
        'Anahtar sözcük gruplarından sadece ayrı sözcükler çıkarılabilir, sözcük grupları çıkarılamaz: {phrase}',
    'phrase-only-stop-words': 'Anahtar sözcük grubu sadece stop sözcüklerinden (bağlaç, edat vs) oluşamaz: {phrase}',
    'phrase-plus-mark-in-brackets':
        '"+" işareti köşeli parantez içinde kullanılamaz. Anahtar sözcük grubunda hata var: {phrase}',
    'phrase-too-long-keyword':
        'Anahtar sözcük grubunda izin verilen satır uzunluğu {maxLength} karakter aşıldı: {phrase}',
    'phrase-too-long-word':
        'Belirli bir anahtar sözcüğünün izin verilen uzunluğu {maxLength} karakter aşıldı. Sözcüklerde hatalar var: {word}',
    'phrase-too-many-words':
        'Anahtar sözcük grubu en fazla {maxWords} kelimeden oluşabilir. Sözcük grubunda hatalar var: {phrase}',
    'phrases-cannot-be-empty': 'Anahtar sözcük grupları belirtilmelidir',
    'retargeting-condition-cannot-be-empty': 'Gösterim koşulu belirtilmelidir',
    'retargeting-condition-name-cannot-be-empty': 'Hedef kitle adını belirtin',
    'retargeting-condition-not-found': 'Seçilen koşullardan biri silindi',
    'retargeting-condition-only-symbols':
        'Koşul adında sadece Türkçe, Rusça, Ukraynaca, Kazakça harfler, Latin harfleri, rakamlar ve noktalama işaretleri kullanılabilir.',
    'retargeting-conditions-name-max-length': 'İsim uzunluğu {maxLength} karakteri geçmemelidir',
    'tags-duplicated-error': 'Etiketler benzersiz olmalıdır',
    'tags-invalid-value': 'Bir etiket; sadece Latin harfleri, rakamlar, alt çizgi ve kısa çizgi içermelidir',
    'tags-keyword-length-max': {
        one: 'Maksimum etiket uzunluğu: {maxLength} karakter',
        some: 'Maksimum etiket uzunluğu: {maxLength} karakter',
        many: 'Maksimum etiket uzunluğu: {maxLength} karakter',
        none: 'Maksimum etiket uzunluğu: {maxLength} karakter'
    },
    'tags-keywords-max': 'Maksimum bağlı etiket sayısı: {maxSize}',
    'test-page-error': 'Hata oluştu. Lütfen, reklam alanları haritasını açıp "Kaydet" butonuna tıklayın.',
    'too-wide-geotargeting-smart': "Grubun coğrafi hedeflemesi, akıllı banner'larının ülke listesinden daha geniş",
    'yandexuids-cannot-be-empty': 'Alan boş bırakılamaz',
    'yandexuids-invalid-value': 'Hatalı değer (17-19 haneli değer girin)'
};
